module.exports = __webpack_public_path__ + "img/fishing.7f06c60c.svg";